module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/125-finland-b602d1d7840b026cad4a52ea4b68a23e.svg";